/** Primary Invincible office line for click-to-call on event detail (not trek consultant mobile). */
export const DEFAULT_OFFICE_PHONE_DIGITS = '9099400699';

export function parseNthPhoneDigits(raw, index = 0) {
  const line = String(raw || '')
    .split(/\n|,|;/)
    .map((s) => s.trim())
    .filter(Boolean)[index];
  if (!line) return '';
  const digits = line.replace(/\D/g, '');
  if (digits.length === 12 && digits.startsWith('91')) return digits.slice(2);
  if (digits.length >= 10) return digits.slice(-10);
  return digits;
}

export function parseFirstPhoneDigits(raw) {
  return parseNthPhoneDigits(raw, 0);
}

export function buildTelHrefFromDigits(digits) {
  const d = String(digits || '').replace(/\D/g, '');
  if (!d) return null;
  if (d.length === 10) return `tel:+91${d}`;
  return `tel:+${d}`;
}

/** `tel:` link for office — uses site `contact_phone` first line, else 9099400699. */
export function resolveOfficeTelHref(contactPhoneSetting) {
  const digits = parseFirstPhoneDigits(contactPhoneSetting) || DEFAULT_OFFICE_PHONE_DIGITS;
  return buildTelHrefFromDigits(digits);
}

/** Split "9099400699 / 9913800699" or primary + secondary into dialable segments. */
export function parsePhoneDisplaySegments(...values) {
  const segments = [];
  for (const val of values) {
    if (val == null || val === '') continue;
    String(val)
      .split(/\s*\/\s*|\s*,\s*|\s*;\s*/)
      .map((s) => s.trim())
      .filter(Boolean)
      .forEach((s) => {
        if (!segments.includes(s)) segments.push(s);
      });
  }
  return segments;
}

export function buildTelHrefFromDisplay(display) {
  const digits = parseFirstPhoneDigits(display);
  return buildTelHrefFromDigits(digits);
}
